var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 21 17" }, props),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-warning"] || "oc-icon-status-warning"), d: "M20.1 14L12.3 1.3c-1-1.6-2.6-1.6-3.6 0L.9 14c-1 1.6-.2 3 1.7 3h15.8c1.9 0 2.7-1.4 1.7-3zM9.2 5.8c-.1-.6.4-1.2 1-1.2.6-.1 1.2.4 1.2 1v3.6c.1.6-.4 1.2-1 1.2-.6.1-1.2-.4-1.2-1V5.8zm1.1 8.4c-.7 0-1.3-.6-1.3-1.4 0-.7.6-1.3 1.4-1.3.7 0 1.3.6 1.3 1.3 0 .8-.6 1.4-1.4 1.4z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Warning.svg